import React from 'react';
import { TextField } from '@cimpress/react-components';

interface Props {
    name: string;
    description: string;
    noBackgrounds: boolean;
    onChangeName: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onChangeDescription: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isBulkMode: boolean;
}

const Properties: React.FC<Props> = ({
    name,
    description,
    onChangeName,
    onChangeDescription,
    noBackgrounds,
    isBulkMode,
}) => {
    return (
        <div className='save-properties'>
            <TextField
                className='save-properties__input'
                data-testid='editor-sceneInformation-name'
                value={isBulkMode ? 'Disabled due to bulk mode' : name}
                onChange={onChangeName}
                label='Name of your Scene'
                type='text'
                disabled={noBackgrounds || isBulkMode}
            />
            <TextField
                className='save-properties__input'
                data-testid='editor-sceneInformation-description'
                value={description}
                onChange={onChangeDescription}
                label='Description'
                type='text'
                disabled={noBackgrounds}
            />
        </div>
    );
};

export default React.memo(Properties);
